/**
 * HTML sanitization helpers used by print/PDF flows that build markup from
 * server-supplied data (student names, invoice fields, etc.).
 *
 * Prevents XSS via innerHTML / document.write when a value like
 * "<script>alert(1)</script>" appears inside a full_name or subject field.
 */

const REPLACEMENTS = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;",
  "`": "&#x60;",
  "=": "&#x3D;",
};

/**
 * Escape a value for safe interpolation inside an HTML template literal.
 * Non-string values are coerced via String().
 */
export function escapeHtml(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[&<>"'`=/]/g, (c) => REPLACEMENTS[c] || c);
}

/**
 * Escape an attribute value (URLs, class names, etc.).
 * Same as escapeHtml but explicit for readability at call sites.
 */
export const escapeAttr = escapeHtml;
